export default __webpack_public_path__ + "75610cc79f309a861b353282229013d5.png";